import React from 'react';
import { 
  Box, 
  Typography, 
  Container,
  styled 
} from '@mui/material';

const ImageWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  boxShadow: theme.shadows[4],
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.02)'
  }
}));

const HowItWorksSection = () => {
  return (
    <Box 
      component="section" 
      id="how"
      sx={{
        py: 8,
        bgcolor: 'white'
      }}
    >
      <Container>
        <Typography 
          variant="h3" 
          component="h2"
          align="center"
          sx={{
            color: '#0d9488',
            fontWeight: 700,
            mb: 6
          }}
        >
          How It Works
        </Typography>
        
        <ImageWrapper>
          <img
            src="/how-it-works.jpg"
            alt="Searchable Integration Process"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          />
        </ImageWrapper>
      </Container>
    </Box>
  );
};

export default HowItWorksSection;